import { RootState } from '../store';

export const selectOmniSetup = (state: RootState) => state.omniSetup;
